"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("../Modal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var Href = function Href(props) {
  var _a = props || {},
    txt = _a.txt,
    href = _a.href,
    _b = _a.extendProps,
    extendProps = _b === void 0 ? {} : _b;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "item"
  }, /*#__PURE__*/_react["default"].createElement("a", __assign({}, extendProps, {
    href: href,
    className: "item__href"
  }), txt));
};
var ModalItem = function ModalItem(props) {
  var _a = props || {},
    txt = _a.txt,
    handle = _a.handle,
    modalTitle = _a.modalTitle,
    setModalList = _a.setModalList,
    _b = _a.list,
    list = _b === void 0 ? [] : _b,
    setModalContent = _a.setModalContent,
    _c = _a.richTextContent,
    richTextContent = _c === void 0 ? '' : _c,
    _d = _a.extendProps,
    extendProps = _d === void 0 ? {} : _d;
  return /*#__PURE__*/_react["default"].createElement("li", __assign({}, extendProps, {
    className: "item",
    onClick: function onClick() {
      if (handle) {
        handle(true);
        setModalList({
          list: list,
          modalTitle: modalTitle
        });
        setModalContent(richTextContent);
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "item__modal"
  }, txt));
};
var FlexModal = function FlexModal(props) {
  var _a = props.modalList,
    modalList = _a === void 0 ? [] : _a;
  var _b = (0, _react.useState)(false),
    status = _b[0],
    setStatus = _b[1];
  var _c = (0, _react.useState)({}),
    list = _c[0],
    setModalList = _c[1];
  var _d = (0, _react.useState)(''),
    modalContent = _d[0],
    setModalContent = _d[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "flex-title__modal"
  }, modalList.map(function (item, index) {
    var _a = item || {},
      txt = _a.txt,
      type = _a.type,
      href = _a.href,
      modalTitle = _a.modalTitle,
      richBtnTxt = _a.richBtnTxt,
      richTextContent = _a.richTextContent,
      extendProps = _a.extendProps;
    switch (type) {
      case 'href':
        return /*#__PURE__*/_react["default"].createElement(Href, {
          txt: txt,
          href: href,
          key: index,
          extendProps: extendProps
        });
      default:
        return /*#__PURE__*/_react["default"].createElement(ModalItem, {
          key: index,
          txt: txt,
          handle: setStatus,
          setModalList: setModalList,
          setModalContent: setModalContent,
          richTextContent: richTextContent,
          list: richBtnTxt,
          modalTitle: modalTitle,
          extendProps: extendProps
        });
    }
  })), status && (/*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    close: function close() {
      setStatus(false);
    },
    modalList: list,
    modalContent: modalContent
  })));
};
var _default = exports["default"] = FlexModal;